

import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EMPLOYER_URL } from "../../../resources/resource";
import { useFetchData } from "../../../hooks/useFtechData";
import { useSelector } from "react-redux";
import ProfileCard from "../Profile";
import ProfileForm from "../ProfileForm";
// import ProofSection from '../ProofAddress';
// import FaceAuthentication from './FaceAuthentication';
// import EmployerVerificationForm from './EmployerVerificationForm';

const Profile = () => {
  const currentUser = useSelector((state) => state.user.currentUser);

  const { data, refetch } = useFetchData(
    EMPLOYER_URL + `/getJobEmployer/${currentUser?._id}`
  );

  const navigate = useNavigate();
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      if (data?.employers?.length) {
        try {
          const details = await Promise.all(
            data.employers.map(async (id) => {
              const response = await fetch(
                `${EMPLOYER_URL}/getEmployeeDetails/${id}`
              );
              const empData = await response.json();
              return { id, name: empData.name || `Employee ${id}` };
            })
          );
          setEmployeeDetails(details);
        } catch (error) {
          console.error("Error fetching employee details:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchEmployeeDetails();
  }, [data]);

  return (
    <div className="max-w-4xl mx-auto px-4 py-6 space-y-6">
      {/* Profile header card (avatar, company name, etc.) */}
      <ProfileCard user={data} refetch={refetch} />

      {/* Editable profile form — pass API data, not Redux slice */}
      <div className="bg-white shadow-sm rounded-xl p-5 sm:p-6">
        <ProfileForm
          user={data}          // ← full employer document from API
          onInputChange={() => {}}
        />
      </div>

      {/* Uncomment when ready:
      <FaceAuthentication />
      <EmployerVerificationForm />
      <ProofSection
        title="Proof of Address"
        proofs={data?.proofOfCompany}
        refetch={refetch}
      />
      */}
    </div>
  );
};

export default Profile;